import { FIELD_TYPE } from "@saleor/components/FormField/constants";
import { UploadType, useScgpMeQuery } from "@saleor/graphql";
import { useFormik } from "formik";
import { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";

const useExcelUploadFilter = () => {
  const intl = useIntl();

  const { data: scgpMe } = useScgpMeQuery({
    displayLoader: true
  });

  const orderTypeList = [
    { label: "ZP20 - Cash", value: "ZP20" },
    { label: "ZP30 - Credit", value: "ZP30" }
  ];

  const salesOrganizationList = useMemo(() => {
    const orgList =
      scgpMe?.scgpMe?.extendData?.salesOrgByBuAndUser
        ?.find(org => org?.businessUnit === "CIP")
        ?.salesOrganizations?.map(e => ({
          label: `${e.code} - ${e.shortName ? e.shortName : ""}`,
          value: e.code
        })) || [];
    return orgList;
  }, [scgpMe?.scgpMe?.extendData?.salesOrgByBuAndUser]);

  const distributionChannelList = [
    {
      label: intl.formatMessage({ defaultMessage: "10 - Domestic Direct" }),
      value: "10"
    }
  ];

  const divisionList = [
    {
      label: intl.formatMessage({ defaultMessage: "00 - Common" }),
      value: "00"
    }
  ];

  const uploadTypeOptions = [
    {
      label: intl.formatMessage({ defaultMessage: "Grouping by PO" }),
      value: UploadType.GROUP
    },
    {
      label: intl.formatMessage({ defaultMessage: "No Grouping" }),
      value: UploadType.NOT_GROUP
    }
  ];

  const formik = useFormik({
    initialValues: {
      orderType: "ZP30",
      saleOrganization: "",
      distributionChannel: "10",
      division: "00",
      uploadType: UploadType.GROUP
    },
    onSubmit: () => {
      //
    }
  });

  useEffect(() => {
    const salesOrgByBuAndUser = scgpMe?.scgpMe?.extendData?.salesOrgByBuAndUser?.find(
      org => org?.businessUnit === "CIP"
    )?.salesOrganizations;
    formik.setValues(prev => ({
      ...prev,
      saleOrganization:
        salesOrgByBuAndUser?.length === 1 ? salesOrgByBuAndUser[0].code : ""
    }));
  }, [scgpMe?.scgpMe?.extendData?.salesOrgByBuAndUser]);

  const formData = useMemo(
    () => [
      {
        title: intl.formatMessage({ defaultMessage: "Order Type" }),
        name: "orderType",
        placeholder: intl.formatMessage({
          defaultMessage: "เลือก Order Type"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: orderTypeList
      },
      {
        title: intl.formatMessage({ defaultMessage: "Sales Organization" }),
        name: "saleOrganization",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "เลือก Sales Organization"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: salesOrganizationList
      },
      {
        title: intl.formatMessage({ defaultMessage: "Distribution Channel" }),
        name: "distributionChannel",
        placeholder: intl.formatMessage({
          defaultMessage: "เลือก Distribution Channel"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: distributionChannelList
      },
      {
        title: intl.formatMessage({ defaultMessage: "Division" }),
        name: "division",
        placeholder: intl.formatMessage({
          defaultMessage: "เลือก Division"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: divisionList
      },
      {
        title: intl.formatMessage({ defaultMessage: "Upload Type" }),
        name: "uploadType",
        options: uploadTypeOptions,
        type: FIELD_TYPE.RADIO_GROUP,
        sm: 12,
        md: "auto"
      }
    ],
    [
      orderTypeList,
      salesOrganizationList,
      distributionChannelList,
      divisionList,
      uploadTypeOptions
    ]
  );

  return {
    formik,
    formData
  };
};
export default useExcelUploadFilter;
